import { useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { BACKEND } from "@/lib/api";

export default function PublicLanding() {
  const { slug } = useParams();
  const { search } = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    fetch(`${BACKEND}/api/p/${slug || "_default"}${search}`)
      .then((r) => r.text())
      .then((html) => { document.open(); document.write(html); document.close(); });
  }, [slug, search]);
  return <div data-testid="public-landing-loading" style={{ padding: 40, color: "#64748b" }}>Loading…</div>;
}
